// extracted by mini-css-extract-plugin
export default {"container":"businessDistribution_container__x1UIu","row":"businessDistribution_row__mPoEv","chart":"businessDistribution_chart__oZwEZ","table":"businessDistribution_table__dC9KD"};